import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export type AppStatus = 'checking' | 'available' | 'unavailable';

@Injectable({ providedIn: 'root' })
export class AppStatusService {
  private readonly status = new BehaviorSubject<AppStatus>('checking');
  readonly status$ = this.status.asObservable();

  setStatus(status: AppStatus): void {
    this.status.next(status);
  }
}
